import { createFileRoute } from '@tanstack/react-router';

import { VerifyDomainPage } from 'src/apps/enterprise/app/pages/VerifyDomain';

export const Route = createFileRoute('/_auth/enterprise/enroll/verify-domain')({
  component: () => <VerifyDomainPage />,
});
